import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "react-beautiful-dnd";
import * as S from "../style";
import * as C from "../../base/style";
import { YoutubeLiveResponse } from "../../../../../../../api/youtube-live";
import { useTournamentContext } from "../../../../../hook/context";

const LiveList = () => {
  const { liveList, setLiveList } = useTournamentContext();

  const handleLinkValue = (index: number, value: string | null) => {
    if (index === -1) {
      return;
    }

    setLiveList((prevList: YoutubeLiveResponse[]) => {
      const newList = [...prevList];
      const item = newList[index];
      item.link = value ?? "";
      return newList;
    });
  };

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const newList = reorder(
      liveList,
      result.source.index,
      result.destination.index
    ).map((item, idx) => ({ ...item, order: idx + 1 }));
    setLiveList(newList);
  };

  const reorder = <T,>(
    list: T[],
    startIndex: number,
    endIndex: number
  ): T[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleLiveToggle = (index: number) => {
    setLiveList((prevList) => {
      const newList = [...prevList];
      const item = newList[index];

      item.isLive = !item.isLive;
      return newList;
    });
  };

  return (
    <C.EditTournamentBaseWrapper>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="live-setting-list">
          {(provided) => (
            <S.LiveSettingListWrapper
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {liveList.map((item, i) => {
                const draggableId =
                  item.id != null
                    ? `id-${item.id}`
                    : `attendee-${item.attendeeId}`;
                return (
                  <Draggable
                    draggableId={`live-youtube-${draggableId}`}
                    index={i}
                    key={draggableId}
                  >
                    {(provided) => (
                      <C.EditTournamentBaseContent
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                      >
                        <S.LiveSettingListItemHeader>
                          <div className="left">
                            <S.LiveSettingDragHandle
                              {...provided.dragHandleProps}
                              aria-label="순서 변경"
                            >
                              <img src="/image-web/edit/drag.svg" alt="" />
                            </S.LiveSettingDragHandle>
                            <div className="wrapper">
                              <div className="ord">{i + 1}</div>
                              <div className="name">{item.name} </div>
                            </div>
                          </div>
                          <S.LiveSettingToggleWrapper isLiveOn={item.isLive}>
                            <S.LiveSettingToggleItem
                              isLiveOn={item.isLive}
                              onClick={() => handleLiveToggle(i)}
                            >
                              <S.LiveSettingToggleCircle
                                isLiveOn={item.isLive}
                              />
                            </S.LiveSettingToggleItem>
                          </S.LiveSettingToggleWrapper>
                        </S.LiveSettingListItemHeader>
                        <C.EditTournamentInputBox>
                          <input
                            placeholder="라이브 방송 링크를 입력하세요. "
                            type="text"
                            value={item.link}
                            onChange={(e) => handleLinkValue(i, e.target.value)}
                          />
                        </C.EditTournamentInputBox>
                      </C.EditTournamentBaseContent>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </S.LiveSettingListWrapper>
          )}
        </Droppable>
      </DragDropContext>
    </C.EditTournamentBaseWrapper>
  );
};

export default LiveList;
